import '../styles/ContactButton/index.css';
import { motion } from 'motion/react';
import { Icon } from "@iconify/react";

export default function ContactButton({ status = 'idle', errorMessage, ...other }) {
    return (
        <motion.button 
            className={`button mt-4 ${status} transition-all`} 
            initial="initial"
            animate={status}
            {...other}
        >
            <div className="outline"></div>
            <motion.div 
                className="state state--default"
                variants={{
                    idle: { opacity: 1, display: 'flex' },
                    sending: { opacity: 0, transition: { duration: 0.3 } },
                    success: { opacity: 0, display: 'none' },
                    error: { opacity: 0, display: 'none' },
                }}
            >
                <div className="icon">
                    <Icon icon="lets-icons:send-fill" width="1em" height="1em" style={{ marginLeft: '10px', marginBottom: '8px' }}/>
                </div>
                <p className="!text-sm sm:!text-base md:!text-base lg:!text-lg">
                    <span style={{ '--i': 0 }}>L</span>
                    <span style={{ '--i': 1 }}>e</span>
                    <span style={{ '--i': 2 }}>t</span>
                    <span style={{ '--i': 3 }}>s</span>
                    <span style={{ '--i': 4 }}>W</span>
                    <span style={{ '--i': 5 }}>o</span>
                    <span style={{ '--i': 6 }}>r</span>
                    <span style={{ '--i': 7 }}>k</span>
                    <span style={{ '--i': 8 }}>T</span>
                    <span style={{ '--i': 9 }}>o</span>
                    <span style={{ '--i': 10 }}>g</span>
                    <span style={{ '--i': 11 }}>e</span>
                    <span style={{ '--i': 12 }}>t</span>
                    <span style={{ '--i': 13 }}>h</span>
                    <span style={{ '--i': 14 }}>e</span>
                    <span style={{ '--i': 15 }}>r</span>
                </p>
            </motion.div>
            
            <motion.div 
                className="state state--sending"
                variants={{
                    idle: { opacity: 0, display: 'none' },
                    sending: { opacity: 1, display: 'flex' },
                    success: { opacity: 0, display: 'none' },
                    error: { opacity: 0, display: 'none' },
                }}
            >
                <div className="icon !ml-10">
                    <motion.svg
                        width="1.2em"
                        height="1.2em"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        animate={{ rotate: 360 }}
                        transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
                    >
                        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeDasharray="30 30" strokeDashoffset="0" />
                    </motion.svg>
                </div>
                <p className="!text-sm sm:!text-base md:!text-base lg:!text-base">
                    <span style={{ '--i': 0 }}>S</span>
                    <span style={{ '--i': 1 }}>e</span>
                    <span style={{ '--i': 2 }}>n</span>
                    <span style={{ '--i': 3 }}>d</span>
                    <span style={{ '--i': 4 }}>i</span>
                    <span style={{ '--i': 5 }}>n</span>
                    <span style={{ '--i': 6 }}>g</span>
                </p>
            </motion.div>
            
            <motion.div 
                className="state state--sent"
                variants={{
                    idle: { opacity: 0, display: 'none' },
                    sending: { opacity: 0, display: 'none' },
                    success: { opacity: 1, display: 'flex', transition: { delay: 0.2 } },
                    error: { opacity: 0, display: 'none' },
                }}
            >
                <div className="icon !ml-10">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        height="1.2em"
                        width="1.2em"
                    >
                        <circle cx="12" cy="12" r="10" stroke="currentColor" fill="none" strokeWidth="1.5" />
                        <path
                            d="M8 12L11 15L16 9"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
                <p className="!text-sm sm:!text-base md:!text-base lg:!text-base">
                    <span style={{ '--i': 0 }}>S</span>
                    <span style={{ '--i': 1 }}>e</span>
                    <span style={{ '--i': 2 }}>n</span>
                    <span style={{ '--i': 3 }}>t</span>
                </p>
            </motion.div>
            
            <motion.div 
                className="state state--error"
                variants={{
                    idle: { opacity: 0, display: 'none' },
                    sending: { opacity: 0, display: 'none' },
                    success: { opacity: 0, display: 'none' },
                    error: { opacity: 1, display: 'flex', transition: { delay: 0.2 } },
                }}
            >
                <div className="icon !ml-3">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        height="1.2em"
                        width="1.2em"
                    >
                        <circle cx="12" cy="12" r="10" stroke="#dc2626" fill="none" strokeWidth="1.5" />
                        <path
                            d="M15 9L9 15M9 9L15 15"
                            stroke="#dc2626"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                    </svg>
                </div>
                <p className="!text-sm sm:!text-base md:!text-base lg:!text-base">
                    <span style={{ '--i': 0 }}>T</span>
                    <span style={{ '--i': 1 }}>r</span>
                    <span style={{ '--i': 2 }}>y&nbsp;</span>
                    <span style={{ '--i': 4 }}>A</span>
                    <span style={{ '--i': 5 }}>g</span>
                    <span style={{ '--i': 6 }}>a</span>
                    <span style={{ '--i': 7 }}>i</span>
                    <span style={{ '--i': 8 }}>n</span>
                </p>
            </motion.div>
        </motion.button>
    )
}

